import {
    ButtonPrimary,
    ButtonSecondary,
    ButtonProps,
    ButtonText,
    ButtonTertiary,
} from '@motili/ui';

interface StyledButtonProps extends ButtonProps {
    variant?: 'primary' | 'secondary' | 'tertiary';
}

const StyledButton = ({ variant, ...buttonProps }: StyledButtonProps) => {
    switch (variant) {
        case 'primary':
            return <ButtonPrimary {...buttonProps} />;
        case 'secondary':
            return <ButtonSecondary {...buttonProps} />;
        case 'tertiary':
            return <ButtonTertiary {...buttonProps} />;
        default:
            return <ButtonText {...buttonProps} />;
    }
};

export default StyledButton;
